import React, { FunctionComponent } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { Review } from '../types/review.type';

type ReviewStatusLabelProps = {
  review: Review;
};

export const ReviewStatusLabel: FunctionComponent<ReviewStatusLabelProps> = ({
  review,
}) => {
  if (review.isSpam) {
    return (
      <Label color="grey" size="small">
        <Icon name="ban" />
        Spam
      </Label>
    );
  }

  switch (review.status) {
    case 'ok':
      return (
        <Label color="green" size="small">
          Validé
        </Label>
      );
    case 'ko':
      return (
        <Label color="grey" size="small">
          Refusé
        </Label>
      );
    default:
      return (
        <Label color="red" size="small">
          En attente
        </Label>
      );
  }
};
